import { render, staticRenderFns } from "./OFileUpload.vue?vue&type=template&id=d728f556&scoped=true&"
import script from "./OFileUpload.vue?vue&type=script&lang=js&"
export * from "./OFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d728f556",
  null
  
)

export default component.exports